import { BellIcon } from "icons/outline";
import { Link } from "ui";
import { PageBanner } from "../../../components/PageBanner";

export function AlertsBanner() {
  return (
    <PageBanner
      className="mb-6"
      imageUrl="/images/alerts-banner.png"
      imageClassName="lg:-mt-4"
    >
      <PageBanner.Title>
        <PageBanner.Icon
          className="bg-danger-subtler text-danger"
          Icon={BellIcon}
        />
        <PageBanner.TitleText>Alerts</PageBanner.TitleText>
      </PageBanner.Title>

      <PageBanner.Heading>Get alerted about your metrics</PageBanner.Heading>

      <PageBanner.Description>
        Customize alert preferences to receive timely notifications that help
        you respond quickly and keep your operations running smoothly.
      </PageBanner.Description>

      <Link href="/settings/alerts" target="_blank" className="mb-8">
        Configure Alerts
      </Link>
    </PageBanner>
  );
}
